import { motion, AnimatePresence } from 'framer-motion';
import { useEffect, useState } from 'react';
import { BRAND } from '@/lib/site';

export default function LoadingScreen() {
  const [show, setShow] = useState(true);

  useEffect(() => {
    const t = setTimeout(() => setShow(false), 1900);
    return () => clearTimeout(t);
  }, []);

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          data-testid="loading-screen"
          initial={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.7, ease: 'easeInOut' }}
          className="fixed inset-0 z-[100] flex items-center justify-center bg-cream dark:bg-[#1A0F14] grain"
        >
          {/* Mandala backdrop */}
          <div className="pointer-events-none absolute inset-0 bg-mandala bg-center bg-no-repeat opacity-50 animate-slow-spin" />
          {/* Saffron glow */}
          <div className="pointer-events-none absolute inset-0 bg-saffron-glow" />

          <div className="relative z-10 flex flex-col items-center gap-6">
            <motion.div
              initial={{ scale: 0.6, opacity: 0, filter: 'blur(8px)' }}
              animate={{ scale: 1, opacity: 1, filter: 'blur(0px)' }}
              transition={{ duration: 1.0, ease: [0.16, 1, 0.3, 1] }}
              className="relative"
            >
              <div className="absolute inset-0 -z-10 rounded-full bg-saffron-glow scale-150 animate-pulse-glow" />
              <img
                src={BRAND.logo}
                alt="ADI Foundation"
                className="h-32 w-32 object-contain mix-blend-multiply drop-shadow-[0_8px_24px_rgba(255,103,31,0.45)]"
              />
            </motion.div>
            <motion.div
              initial={{ opacity: 0, y: 8 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.6, duration: 0.6 }}
              className="text-center"
            >
              <p className="font-devanagari text-maroon-600 dark:text-saffron-300 text-lg tracking-wide">
                {BRAND.taglineHi}
              </p>
              <p className="mt-1 eyebrow">{BRAND.tagline}</p>
            </motion.div>
            <motion.div
              initial={{ width: 0 }}
              animate={{ width: 180 }}
              transition={{ delay: 0.4, duration: 1.2, ease: 'easeInOut' }}
              className="h-[2px] bg-gradient-to-r from-transparent via-saffron-500 to-transparent"
            />
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
